export default {
  inspirations: 'Inspirations',
  gifts: 'Cadeaux',
  occasions: 'Occasions',
  'tutorials-and-advices': 'Tutoriels et conseils',
  'home-furnishing': 'Décoration intérieure',
  highlights: 'Highlights',
}
